module.exports = __webpack_public_path__ + "img/Icon_Compensation.999a221f.png";